import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssessmentCompletionTemplate from '../components/AssessmentCompletionTemplate';
import { createNutritionalAssessmentConfig } from '../config/assessmentCompletionConfigs';

interface NutritionalAssessmentResult {
  id: string;
  assessmentType: string;
  scores: {
    overall: number;
    healthyFoods: number;
    unhealthyFoods: number;
  };
  results: {
    level: 'Low' | 'Moderate' | 'High';
    interpretation: string;
    recommendations: string[];
  };
  createdAt: string;
}

const NutritionalAssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the assessment result from navigation state
  const assessmentResult = location.state?.assessmentResult as NutritionalAssessmentResult;
  
  // Debug: Log the received data
  
  if (!assessmentResult) {
    // If no result data, redirect to insights
    navigate('/panel/learn/');
    return null;
  }

  if (!assessmentResult.scores || !assessmentResult.results) {

    navigate('/panel/learn/');
    return null;
  }

  try {
    // Create configuration using the template system
    const config = createNutritionalAssessmentConfig(assessmentResult);
    
    // Use the template component
    return <AssessmentCompletionTemplate config={config} />;
  } catch (error) {

    navigate('/panel/learn/');
    return null;
  }
};

export default NutritionalAssessmentCompletionPage;


